import axios from './api';

const getList = (params: any) => (
  axios.request({
    method: 'GET',
    url: '/hourapp/getUserReportPlanList',
    params,
  })
);

export default getList;
